import React, { memo } from 'react';
import { Flame } from 'lucide-react';
import { cn } from '../lib/utils';

const StreakBadge = memo(function StreakBadge({ count, size = 'md', showLabel = true }) {
  const isActive = count > 0;
  
  const sizeClasses = {
    sm: 'text-sm gap-1',
    md: 'text-lg gap-2',
    lg: 'text-2xl gap-2'
  };
  
  const iconSizes = {
    sm: 16,
    md: 24,
    lg: 32
  };
  
  return (
    <div 
      className={cn(
        'flex items-center font-serif',
        sizeClasses[size]
      )}
      data-testid="streak-badge"
    >
      <Flame 
        size={iconSizes[size]} 
        className={cn(
          'transition-all duration-300',
          isActive ? 'text-coral-500 streak-fire' : 'text-cream-400'
        )}
        strokeWidth={1.5}
        fill={isActive ? '#CC7A6F' : 'none'}
      />
      <span className={cn(
        'font-semibold',
        isActive ? 'text-cream-900' : 'text-wood-500'
      )}>
        {count}
      </span>
      {showLabel && (
        <span className="text-sm text-wood-500 font-sans font-normal ml-1">
          {count === 1 ? 'day' : 'days'}
        </span>
      )}
    </div>
  );
});

export default StreakBadge;
